// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//Actions, Services, Selectors
import * as actions from 'actions';
import { isRegistered } from 'services/userInfoService';
import { currentUserSelector } from 'selectors';
import { ConditionalActionButton } from 'frontend-component-library';

import { MODAL_NAME, FORM_KEYS } from 'Components/Auth/AuthModal';

class PrivateActionButton extends Component {
  handleFailure = () => {
    this.props.openModal(MODAL_NAME, { formToDisplay: FORM_KEYS.login });
  };

  render() {
    const {
      className,
      onClick,
      children,
      openModal,
      ...otherProps
    } = this.props;
    return (
      <ConditionalActionButton
        className={`${this.props.className} btn`}
        conditional={isRegistered(this.props.user)}
        onSuccess={this.props.onClick}
        onFailure={this.handleFailure}
        {...otherProps}
      >
        {children}
      </ConditionalActionButton>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: currentUserSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: actions.openModal,
    },
    dispatch
  );
}

PrivateActionButton.defaultProps = {
  className: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(
  PrivateActionButton
);



// WEBPACK FOOTER //
// ./src/Components/Auth/PrivateActionButton.js